export const lightenColorToRgba = (color, alpha) => {
	let hex = color.replace(/^#/, '');
	if (hex.length === 3) {
		hex = hex.split('').map(char => char + char).join('');
	}

	const [r, g, b] = [0, 1, 2].map(i =>
		parseInt(hex.substr(i * 2, 2), 16)
	);

	const brightness = (r * 0.299 + g * 0.587 + b * 0.114) / 255;

	const adjustedAlpha = brightness > 0.5 ? alpha : Math.min(alpha + 0.1, 1);

	return `rgba(${r}, ${g}, ${b}, ${adjustedAlpha})`;
};